import { Button, Form } from "antd";
import { useForm } from "antd/lib/form/Form";
import { ReactElement } from "react";
import { useParams } from "react-router-dom";
import { UI_ITONumericInput } from "../../../../../UI_ITO/UI_ITONumericInput/UI_ITONumericInput";
import { useGetApplicationDataToBankQuery } from "../../../../../store/api/applicationBankApi/applicationBank.api";
import { useAddMemberUlMutation } from "../../../../../store/api/applicationBankApi/juridical.api";
import {
  APPLICATION_BANK_STATUS_KKB,
  BANK_NAME,
} from "../../../../../utils/guards/ApplicationBankStatusGuard/types";
import { Guard } from "../../../../../utils/guards/Guard";
import { validateObjectMember } from "../../../../../utils/utilities/validateDataToBank";
import { LegalEntityCard } from "./LegalEntityCard/LegalEntityCard";

import classes from "./LegalEntities.module.css";

/**
 * Компонент отображает юридические лица, связанные с заявкой.
 * Позволяет добавлять новые юридические лица и отображает существующие.
 */
export function LegalEntities(): ReactElement {
  const { applicationBankId, applicationId } = useParams();
  const [form] = useForm();

  const { data } = useGetApplicationDataToBankQuery({
    applicationBankId: Number(applicationBankId),
    applicationId: Number(applicationId),
  });
  const [addMemberUl] = useAddMemberUlMutation();

  const applicationBankStatus = data?.status;

  function addNewLegalEntity(value: { inn: string }) {
    if (applicationBankId && value) {
      addMemberUl({
        applicationBankId: Number(applicationBankId),
        inn: Number(value.inn),
      });
    }
  }

  return (
    <div className={classes.legalEntitiesWrapper}>
      <Guard.ApplicationBankStatus
        allowedStatuses={[
          {
            bank_name: BANK_NAME.KKB,
            type: APPLICATION_BANK_STATUS_KKB.PROCESSING,
          },
          {
            bank_name: BANK_NAME.KKB,
            type: APPLICATION_BANK_STATUS_KKB.REVISION,
          },
          {
            bank_name: BANK_NAME.KKB,
            type: APPLICATION_BANK_STATUS_KKB.RESIGNING,
          },
        ]}
        status={applicationBankStatus}
      >
        <Form
          form={form}
          autoComplete="off"
          name="search_legal_entities"
          onFinish={addNewLegalEntity}
        >
          <div className={classes.titleSearchInput}>Поиск ИНН</div>
          <div className={classes.formWrapper}>
            <Form.Item
              name="inn"
              rules={[{ type: "string" }]}
              className={classes.formItem}
              noStyle
            >
              <UI_ITONumericInput
                type="search"
                allowClear
                placeholder="Введите ИНН"
              />
            </Form.Item>
            <Button
              className={classes.buttonSearch}
              htmlType="submit"
              type="primary"
            >
              Найти
            </Button>
          </div>
        </Form>
      </Guard.ApplicationBankStatus>
      {data?.members_ul?.map((legalEntity) => {
        const { inn, shortname, id, percent } = legalEntity;

        return (
          <LegalEntityCard
            key={id}
            ul_id={id}
            applicationBankStatus={applicationBankStatus}
            {...legalEntity}
            isRequiredFields={validateObjectMember(legalEntity, [
              "shortname",
              "percent",
              "okfs",
              "passport_document",
            ])}
          />
        );
      })}
    </div>
  );
}
